export interface IResourcesStore {
  featuredResources: any[];
  resources: any[];
  skills: any[];
}

export const resourcesStore = {
  featuredResources: [],
  resources: [],
  skills: [],
};
